// The session-codes cache surface (Wave 2 · D2) — the key re-home plus the
// module-scope invalidator, split out of the app-side
// `useQuerySessionClinicalCodes` hook (which stays app-side: Rematch token in
// its queryKey, session reads, review-mode — the useQueryUser mixed-shim
// pattern). The invalidator runs against the app's queryClient singleton via
// the configureCodingData seam — behaviour byte-identical.
import { GET_SESSION_CLINICAL_CODES } from '../../contracts/keys';
import { CodeSystem, type SessionClinicalCodesResponse } from '../../contracts/types';
import { getCodingDataConfig } from '../config';

export { GET_SESSION_CLINICAL_CODES };

const SUPPORTED_CODE_SYSTEMS = new Set<string>(Object.values(CodeSystem));

// Ignore code systems the frontend cannot render.
export const filterSupportedCodeSystems = (
  data: SessionClinicalCodesResponse
): SessionClinicalCodesResponse => ({
  ...data,
  clinical_entities: data.clinical_entities.filter((entity) =>
    SUPPORTED_CODE_SYSTEMS.has(entity.primary_code.code_system)
  ),
});

// [sic] "Sesion" — the historical export name is API surface; renaming is a
// curation follow-up (Z-series), never part of a move.
export const invalidateSesionClinicalCodes = async (sessionId: string) => {
  await getCodingDataConfig().queryClient.invalidateQueries({
    queryKey: [GET_SESSION_CLINICAL_CODES, { sessionId }],
  });
};
